/**
 * FAQ Management Service
 * Handles all API calls for FAQ CRUD operations
 */
import api from './api';

const BASE_PATH = '/admin/ai/faqs';

/**
 * Fetch all FAQs with optional filters
 * @param {Object} params - Query parameters (page, page_size, search, category, is_active)
 * @returns {Promise<Object>} Response with FAQs and pagination info
 */
export const fetchFAQs = async (params = {}) => {
  try {
    const response = await api.get(BASE_PATH + '/', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Fetch a single FAQ by ID
 * @param {number} id - FAQ ID
 * @returns {Promise<Object>} FAQ object
 */
export const fetchFAQ = async (id) => {
  try {
    const response = await api.get(`${BASE_PATH}/${id}/`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Create a new FAQ
 * @param {Object} data - FAQ data (question, answer, category, keywords, priority, is_active)
 * @returns {Promise<Object>} Created FAQ object
 */
export const createFAQ = async (data) => {
  try {
    const response = await api.post(BASE_PATH + '/', data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Update an existing FAQ
 * @param {number} id - FAQ ID
 * @param {Object} data - Updated FAQ data
 * @returns {Promise<Object>} Updated FAQ object
 */
export const updateFAQ = async (id, data) => {
  try {
    const response = await api.patch(`${BASE_PATH}/${id}/`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Delete an FAQ
 * @param {number} id - FAQ ID
 * @returns {Promise<void>}
 */
export const deleteFAQ = async (id) => {
  try {
    await api.delete(`${BASE_PATH}/${id}/`);
  } catch (error) {
    throw error;
  }
};

/**
 * Regenerate embedding for a specific FAQ
 * @param {number} id - FAQ ID
 * @returns {Promise<Object>} Success response
 */
export const regenerateEmbedding = async (id) => {
  try {
    const response = await api.post(`${BASE_PATH}/${id}/regenerate_embedding/`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Bulk regenerate embeddings for all FAQs
 * @returns {Promise<Object>} Success response with count
 */
export const bulkRegenerateEmbeddings = async () => {
  try {
    const response = await api.post(`${BASE_PATH}/bulk_regenerate_embeddings/`);
    return response.data;
  } catch (error) {
    throw error;
  }
};



